import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getOrderFulfillmentAnalyticsAvailability = unaryRpc({
  name: "getOrderFulfillmentAnalyticsAvailability" as const,
  input: z.object({}),
  output: z.object({ available: z.boolean() }),
});
